<template>
	<div>
		<h1 class="mt-0 mb-5">Order #{{ id }}</h1>

		<div v-if="loading">Loading...</div>

		<div v-else>
			<order-details/>
			<order-invoice/>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import OrderDetails from './OrderDetails.vue';
import OrderInvoice from './OrderInvoice.vue';

export default {
	components: { OrderDetails, OrderInvoice },

	props: {
		id: { type: [Number, String], required: true }
	},

	data()
	{
		return {
			loading: true,
		}
	},

	computed: {
		...mapState({
			order: state => state.profile.currentOrder,
		})
	},

	methods: {
		...mapActions('profile', ['fetchOrder']),

		async loadOrder()
		{
			this.loading = true;

			try
			{
				await this.fetchOrder(this.id);
			}
			finally
			{
				this.loading = false;
			}
		}
	},

	mounted()
	{
		this.loadOrder();
	}
}
</script>